import { Box, Button, CardHeader, Divider, Grid, Typography, useTheme } from '@mui/material';
import CheckboxComponent from '../components/Checkbox';
import TruncatedTypography from '../components/TruncatedTypography';
import FormModal from './formModal';

const styles = {
  wrapper: {
    width: '100%',
    padding: 0,
  },
  instructionHeading: {
    fontSize: '0.86rem',
    fontWeight: 600,
    marginBottom: '4px',
  },
  instructions: {
    fontSize: '0.8rem',
    lineHeight: 1.4,
    marginBottom: '24px',
  },
  checkboxGroup: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: '20px',
    rowGap: '12px',
    width: '100%',
    justifyItems: 'start',
    marginBottom: 0,
  },
  checkboxLabel: {
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
  },
  actionButton: {
    width: '120px',
    height: '38px',
  },
  sectionTitle: {
    '&.MuiCardHeader-root': {
      padding: '0 0 8px 0',
    },
  },
};

const FactoryDownloadTemplateModal = ({
  open,
  components,
  selectedComponents,
  onComponentToggle,
  onClose,
  onDownload,
}: any) => {
  const themeData = useTheme();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const selectedComponentIds = Object.keys(selectedComponents || {}).filter((key) => selectedComponents[key]);
    onDownload(selectedComponentIds);
  };

  return (
    <FormModal
      title='SELECT COMPONENT'
      isOpen={open}
      handleSubmit={handleSubmit}
      handleClose={onClose}
      customButtons={
        <Grid container sx={{ ...styles.actions, mt: 0 }}>
          <Button variant='outlined' sx={styles.actionButton} onClick={onClose}>
            CANCEL
          </Button>
          <Button variant='contained' type='submit' sx={styles.actionButton}>
            DOWNLOAD
          </Button>
        </Grid>
      }
      customStyles={{ maxWidth: '460px', width: '560px' }}
    >
      <Box sx={styles.wrapper}>
        <CardHeader
          title='Instructions:'
          sx={styles.sectionTitle}
          titleTypographyProps={{ sx: { ...styles.instructionHeading, color: themeData.palette.text.primary } }}
        />
        <Box component='ul' sx={{ ...styles.instructions, color: themeData.palette.text.secondary, mt: 0, pl: '20px' }}>
          <li>Users must download the Excel template for the specific component under which assets need to be imported.</li>
          <li>A separate Excel sheet must be completed for each component.</li>
          <li>Only assets related to the selected component should be added to its respective Excel sheet.</li>
        </Box>


        <Box sx={styles.checkboxGroup}>
          {(components || []).map((component: any) => {
            const componentKey = String(component?.component_id ?? '');
            const componentName = component?.component_name ?? '';

            if (!componentKey || !componentName) {
              return null;
            }

            return (
              <Box
                key={componentKey}
                component='label'
                htmlFor={`factory-download-${componentKey}`}
                sx={{ ...styles.checkboxLabel, color: themeData.palette.text.primary, minWidth: 0, width: '100%' }}
              >
                <CheckboxComponent
                  name={componentKey}
                  checked={Boolean(selectedComponents?.[componentKey])}
                  handleCheckboxChange={() => onComponentToggle(componentKey)}
                  style={{ p: 0 }}
                />
                <TruncatedTypography sx={{ fontSize: '16px', color: themeData.palette.text.primary }}>
                  {componentName}
                </TruncatedTypography>
              </Box>
            );
          })}
        </Box>

      </Box>
    </FormModal>
  );
};

export default FactoryDownloadTemplateModal;